import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreateSphere } from "@babylonjs/core/Meshes/Builders/sphereBuilder";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { VertexBuffer } from "@babylonjs/core/Buffers/buffer";
import { VertexData } from "@babylonjs/core/Meshes/mesh.vertexData";
import { Area2D } from './../../tool/tools';
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { NumberProperty, PropertyValue, PropertyChangedResult, StringProperty } from "@egr/wcf/modules/core/prop";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { clamp, degToRad } from "@egr/wcf/modules/utils/math";
export class Sphere extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mWidth = 0;
        this.mDepth = 0;
        this.mDiameter = 0;
        this.mMaterial = -1;
        this.mCenter = new Vector2(0, 0);
        this.mminPoint = new Vector2(0, 0);
        this.mmaxPoint = new Vector2(0, 0);
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
    }
    getType() {
        return ("Sphere");
    }
    setAudioSphere(pisAudiSphere = false) {
        this.mRoomElement.setAudioSphere(pisAudiSphere);
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    getPoints() {
        return this.mPoints;
    }
    getPolygon(pOffset = true) {
        let tpolygonPoints = [];
        let tsplinePoints = Util.to3dArray(this.circlePointList());
        for (let tP of tsplinePoints) {
            let tnodePos = new Vector3(0, 0, 0);
            if (pOffset)
                tnodePos = this.mRoomElement.position.clone();
            let tnP = tP.add(tnodePos);
            tpolygonPoints.push(tnP);
        }
        return (tpolygonPoints);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    diameter() {
        return this.mDiameter;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        if (this.mInteractors != null)
            this.mInteractors.showInteractors(pShow);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.0;
        tParams.height = 0.0;
        tParams.floorOffset = 0.0;
        tParams.color = "#999999";
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    setNewRadius(pNewRadius) {
        let tValue = clamp(pNewRadius, 0.05, 500.0);
        let tCPoints = this.getPoints();
        let tradLine = tCPoints[1].subtract(tCPoints[0]);
        tradLine.normalize();
        tradLine = tradLine.scale(tValue);
        tCPoints[1] = tCPoints[0].add(tradLine);
        let tCnewPoints = new Array();
        tCnewPoints.push(tCPoints[0]);
        tCnewPoints.push(tCPoints[1]);
        this.setPoints(tCnewPoints);
    }
    create2dGeometry(pParent) {
        this.mParent = pParent;
        let tCircle = this.createCircle(pParent);
        if (tCircle != null) {
            //tCircle.position.y = - this.mRoomElement.shapeHeight;
            this.mRoomElement.setMesh2d(tCircle);
            this.calcLenght(this.mRoomElement.Params.ElementPoints);
            this.calcSize(this.mRoomElement.Params.ElementPoints);
        }
    }
    create3dGeometry(pParent) {
        let tCircle = this.createCircle(pParent);
        if (tCircle != null) {
            //tCircle.position.y = - this.mRoomElement.shapeHeight;
            this.mRoomElement.setMesh3d(tCircle);
        }
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getProperties() {
        let tProperties = new Array();
        let tYesNoChoices = new Array();
        for (let tYesNo of this.mRoomManager._YesNo) {
            tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
        }
        // global sphere properties
        if (!this.mRoomElement.Params.audioSphere) {
            let tTxtHeight = this.mRoomManager.skyBoxMaterials[0].albedoTexture.vScale;
            //proportional image size
            let tTextureHeightProp = new NumberProperty(this.mRoomElement, Sphere.PROP_KEY_TEXTUREHEIGHT, this.mRoomManager.resources.propertyHeight);
            tTextureHeightProp.getValue = () => new PropertyValue(tTxtHeight);
            tTextureHeightProp.setValue = (pValue) => {
                let tValue = NumberProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.mRoomManager.skyBoxMaterials[0].albedoTexture.vScale = tValue;
                    this.mRoomManager.skyBoxMaterials[0].albedoTexture.notifyTextureMatrixChanged();
                    this.mRoomManager.app.viewer.requestRenderFrame();
                }
                return (Promise.resolve(PropertyChangedResult.Value));
            };
            tProperties.push(tTextureHeightProp);
            return (tProperties);
        }
        // audio file
        const taudioFileProp = new StringProperty(this.mRoomElement, Sphere.PROP_KEY_AUDIOFILE, 'Audio effect');
        taudioFileProp.class = "sound";
        taudioFileProp.choiceList = true;
        taudioFileProp.getChoices = () => Promise.resolve(this.mRoomManager.audio_local_effects);
        taudioFileProp.getValue = () => this.mRoomManager.getSoundEffectPropValue(this.mRoomElement.soundSet.category, this.mRoomElement.soundSet.id);
        taudioFileProp.setValue = (pval) => {
            if (!pval) {
                return Promise.resolve(PropertyChangedResult.Nothing);
            }
            const tValue = StringProperty.ConvertValueToString(pval);
            if (tValue) {
                this.mRoomElement.setAudioFile(tValue);
                return Promise.resolve(PropertyChangedResult.Value);
            }
            return Promise.resolve(PropertyChangedResult.Nothing);
        };
        if (this.mRoomElement.Params.audioSphere) {
            taudioFileProp.visible = true;
        }
        else {
            taudioFileProp.visible = false;
        }
        if (taudioFileProp.visible) {
            tProperties.push(taudioFileProp);
        }
        // audio volume
        const taudioVolumeProp = new NumberProperty(this.mRoomElement, Sphere.PROP_KEY_AUDIOVOLUME, 'Volume');
        taudioVolumeProp.class = "sound";
        taudioVolumeProp.minValue = 0;
        taudioVolumeProp.maxValue = 100;
        taudioVolumeProp.choiceList = false;
        taudioVolumeProp.getValue = () => new PropertyValue(this.mRoomElement.audioVolume);
        taudioVolumeProp.setValue = (pValue) => {
            let tValue = NumberProperty.ConvertValueToNumber(pValue);
            if (tValue != null) {
                this.mRoomElement.setAudioVolume(tValue);
                return (Promise.resolve(PropertyChangedResult.Value));
            }
            return (Promise.resolve(PropertyChangedResult.Nothing));
        };
        if (this.mRoomElement.Params.audioSphere) {
            taudioVolumeProp.visible = true;
        }
        else {
            taudioVolumeProp.visible = false;
        }
        if (taudioVolumeProp.visible) {
            tProperties.push(taudioVolumeProp);
        }
        // // background music
        // const tbgMusicProp = new StringProperty(this.mRoomElement, Sphere.PROP_KEY_BG_MUSIC,
        //     'background music');
        // tbgMusicProp.class = "sound";
        // tbgMusicProp.choiceList = true;
        // tbgMusicProp.getChoices = () => Promise.resolve(this.mRoomManager.BgSound.choiceList_music);
        // tbgMusicProp.getValue = () => this.mRoomManager.BgSound.getPropVal_music();
        // tbgMusicProp.setValue = (pval) => {
        //     if (!pval) {
        //         return Promise.resolve(PropertyChangedResult.Nothing);
        //     }
        //     const tValue = StringProperty.ConvertValueToString(pval);
        //     if (tValue) {
        //         this.mRoomManager.BgSound.setFile_music(tValue);
        //         return Promise.resolve(PropertyChangedResult.Value);
        //     }
        //     return Promise.resolve(PropertyChangedResult.Nothing);
        // };
        // if (this.mRoomElement.Params.audioSphere) {
        //     tbgMusicProp.visible = true;
        // } else {
        //     tbgMusicProp.visible = false;
        // }
        // if (tbgMusicProp.visible) {
        //     tProperties.push(tbgMusicProp);
        // }
        // // audio volume
        // const tbgMusicVolumeProp = new NumberProperty(this.mRoomElement, Sphere.PROP_KEY_BG_MUSIC_VOL,
        //     'audio volume');
        // tbgMusicVolumeProp.class = "sound";
        // tbgMusicVolumeProp.minValue = 0;
        // tbgMusicVolumeProp.maxValue = 100;
        // tbgMusicVolumeProp.choiceList = false;
        // tbgMusicVolumeProp.getValue = () => new PropertyValue(this.mRoomManager.BgSound.audioData_Music.volume);
        // tbgMusicVolumeProp.setValue = (pValue) => {
        //     let tValue = NumberProperty.ConvertValueToNumber(pValue);
        //         if (tValue != null) {
        //             this.mRoomManager.BgSound.setVolume_music(tValue);
        //             return (Promise.resolve(PropertyChangedResult.Value));
        //         }
        //         return (Promise.resolve(PropertyChangedResult.Nothing));
        // };
        // if (this.mRoomElement.Params.audioSphere) {
        //     tbgMusicVolumeProp.visible = true;
        // } else {
        //     tbgMusicVolumeProp.visible = false;
        // }
        // if (tbgMusicVolumeProp.visible) {
        //     tProperties.push(tbgMusicVolumeProp);
        // }
        // // // background effect
        // // const tbgEffectProp = new StringProperty(this.mRoomElement, Sphere.PROP_KEY_BG_EFFECT,
        // //     'background sound');
        // // tbgEffectProp.class = "sound";
        // // tbgEffectProp.choiceList = true;
        // // tbgEffectProp.getChoices = () => Promise.resolve(this.mRoomManager.BgSound.choiceList_effect);
        // // tbgEffectProp.getValue = () => this.mRoomManager.BgSound.getPropVal_effect();
        // // tbgEffectProp.setValue = (pval) => {
        // //     if (!pval) {
        // //         return Promise.resolve(PropertyChangedResult.Nothing);
        // //     }
        // //     const tValue = StringProperty.ConvertValueToString(pval);
        // //     if (tValue) {
        // //         this.mRoomManager.BgSound.setFile_effect(tValue);
        // //         return Promise.resolve(PropertyChangedResult.Value);
        // //     }
        // //     return Promise.resolve(PropertyChangedResult.Nothing);
        // // };
        // // if (this.mRoomElement.Params.audioSphere) {
        // //     tbgEffectProp.visible = true;
        // // } else {
        // //     tbgEffectProp.visible = false;
        // // }
        // // if (tbgEffectProp.visible) {
        // //     tProperties.push(tbgEffectProp);
        // // }
        return (tProperties);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        if (tPoints.length === 2)
            this.setPoints(tPoints);
    }
    setPoints(pPoints) {
        if (pPoints.length !== 2)
            return;
        if (pPoints[0] == null || pPoints[1] == null)
            return;
        let tL1 = Vector3.Distance(pPoints[0], pPoints[1]);
        if (tL1 < 0.05)
            return;
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.mRoomElement.setClosedPolygon(true);
    }
    drawRadiusLine(pParent) {
        let tactTool = this.mRoomManager.app.tools.activeTool;
        if (this.mRoomElement.interactorsVisible || tactTool instanceof Area2D) {
            let tPoints = new Array();
            tPoints.push(new Vector3(0, 0, 0));
            tPoints.push(new Vector3(this.mRoomElement.width * 0.5, 0, 0));
            let tRadiusLine = CreateLines("", { points: tPoints }, this.mScene);
            tRadiusLine.color = Color3.FromHexString("#000000");
            tRadiusLine.parent = pParent;
            tRadiusLine.isPickable = false;
            ShadowGenerator.disableMeshShadow(tRadiusLine);
            this.prepare3dMesh(tRadiusLine);
        }
    }
    calcLenght(pPoints) {
        let tRadius = Vector3.Distance(pPoints[0], pPoints[1]);
        this.mPerimeter = 2 * Math.PI * tRadius;
        this.calcArea(pPoints);
    }
    calcArea(pPoints) {
        let tarea = 0;
        if (pPoints.length < 2)
            return;
        let tRadius = Vector3.Distance(pPoints[0], pPoints[1]);
        tarea = Math.PI * (tRadius * tRadius);
        this.mArea = tarea;
    }
    calcSize(pPoints) {
        if (pPoints.length === 0)
            return;
        let tminX = pPoints[0].x;
        let tminY = pPoints[0].z;
        let tmaxX = pPoints[0].x;
        let tmaxY = pPoints[0].z;
        for (let tPoint of pPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = Vector3.Distance(this.mRoomElement.Params.ElementPoints[0], this.mRoomElement.Params.ElementPoints[1]) * 2;
        this.mDepth = this.mWidth;
        this.mRoomElement.setWidth(this.mWidth, false, false, false);
        this.mRoomElement.setDepth(this.mDepth, false, false);
        this.mminPoint = new Vector2(tminX, tminY);
        this.mmaxPoint = new Vector2(tmaxX, tmaxY);
    }
    centerCircle(pPoints) {
        if (pPoints.length === 0)
            return;
        let tminX = pPoints[0].x;
        let tminY = pPoints[0].y;
        let tmaxX = pPoints[0].x;
        let tmaxY = pPoints[0].y;
        for (let tPoint of pPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.y, tminY);
            tmaxY = Math.max(tPoint.y, tmaxY);
        }
        let tcenter = new Vector3(tmaxX - ((tmaxX - tminX) * 0.5), 0, tmaxY - ((tmaxY - tminY) * 0.5));
        for (let tPoint of pPoints) {
            tPoint.subtractInPlace(Util.to2d(tcenter));
        }
    }
    circlePointList() {
        let tRes = new Array();
        let tDist = Vector3.Distance(this.mPoints[0], this.mPoints[1]);
        let tRadius = tDist > 0 ? tDist : 0.001;
        let tCosA;
        let tSinA;
        for (let i = 0; i < 60; i++) {
            let tDeg = degToRad(i * 6.0 - 360);
            tCosA = Math.cos(tDeg);
            tSinA = Math.sin(tDeg);
            tRes.push(new Vector2(tCosA * tRadius - (tRadius * 0.5), tSinA * tRadius - (tRadius * 0.5)));
        }
        this.centerCircle(tRes);
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    convertToHemisphere(pMesh) {
        let vertexData = new VertexData();
        let indices = pMesh.getIndices();
        let positions = pMesh.getVerticesData(VertexBuffer.PositionKind);
        let tconvIndices = new Array();
        let tDistances = new Array();
        vertexData.indices = indices;
        vertexData.positions = positions;
        let tGap = (this.mRoomElement.width * 0.5) / ((1 / 3) * 11 * 11);
        let tRadius = new Array();
        for (let i = 0; i < 11; i++) {
            tRadius.unshift((1 / 3) * i * i * tGap);
        }
        //let tRadius = [tGap * 10, tGap * 9, tGap * 8, tGap * 7, tGap * 6, tGap * 5, tGap * 4, tGap * 3, tGap * 2, tGap * 1, tGap * 0];
        if (vertexData.positions == null) {
            vertexData.applyToMesh(pMesh);
            return (pMesh);
        }
        for (let i = 0; i < vertexData.positions.length; i += 3) {
            let tpX = vertexData.positions[i];
            let tpY = vertexData.positions[i + 1];
            let tpZ = vertexData.positions[i + 2];
            if (tpY < 0) {
                tconvIndices.push(i);
                tpY = 0;
                vertexData.positions[i + 1] = tpY;
                let tPV = new Vector3(tpX, tpY, tpZ);
                let tDist = Vector3.Distance(Vector3.Zero(), tPV);
                if (tDistances.length === 0) {
                    tDistances.push(tDist);
                }
                else {
                    let tlast = tDistances[tDistances.length - 1];
                    if (!Util.numbersEqual(tDist, tlast)) {
                        tDistances.push(tDist);
                    }
                }
            }
        }
        for (let tIdx of tconvIndices) {
            let tpX = vertexData.positions[tIdx];
            let tpY = vertexData.positions[tIdx + 1];
            let tpZ = vertexData.positions[tIdx + 2];
            if (tpY === 0) {
                let tPV = new Vector3(tpX, tpY, tpZ);
                let tDist = Vector3.Distance(Vector3.Zero(), tPV);
                for (let i = 0; i < tDistances.length; i++) {
                    if (Util.numbersEqual(tDist, tDistances[i])) {
                        let tnewPV = tPV.normalize().scale(tRadius[i]);
                        vertexData.positions[tIdx] = tnewPV.x;
                        vertexData.positions[tIdx + 1] = 0;
                        vertexData.positions[tIdx + 2] = tnewPV.z;
                        break;
                    }
                }
            }
        }
        vertexData.applyToMesh(pMesh);
        return (pMesh);
    }
    createCircle(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        if ((this.mPoints.length !== 2) || (this.mPoints[0] === undefined || this.mPoints[1] === undefined))
            return (null);
        let tmeshOrientation = Mesh.BACKSIDE;
        if (this.mRoomElement.Params.audioSphere) {
            tmeshOrientation = Mesh.DEFAULTSIDE;
        }
        let tradius = Vector3.Distance(this.mPoints[0], this.mPoints[1]);
        let tSphere = CreateSphere("sphere", { segments: 20, diameter: tradius * 2,
            sideOrientation: tmeshOrientation }, this.mScene);
        let tHS = this.convertToHemisphere(tSphere);
        tHS.parent = pParent;
        if (!this.mRoomElement.Params.audioSphere) {
            tHS.material = this.mRoomManager.skyBoxMaterials[0];
            tHS.isPickable = false;
        }
        else {
            tHS.position.y = 0.005;
            tHS.material = this.mRoomElement.localMaterial;
            tHS.visibility = 0.2;
            tHS.isPickable = true;
        }
        ShadowGenerator.disableMeshShadow(tHS);
        return (tHS);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Sphere.PROP_KEY_TEXTUREHEIGHT = "room:RoomElement:textureHeight";
Sphere.PROP_KEY_AUDIOFILE = "room:RoomElement:audioFile";
Sphere.PROP_KEY_AUDIOVOLUME = "room:RoomElement:audioVolume";
Sphere.PROP_KEY_BG_MUSIC = "room:RoomElement:bgMusic";
Sphere.PROP_KEY_BG_EFFECT = "room:RoomElement:bgEffect";
Sphere.PROP_KEY_BG_MUSIC_VOL = "room:RoomElement:bgMusicVolume";
Sphere.PROP_KEY_BG_MUSIC_LOOP = "room:RoomElement:bgMusicLoop";
Sphere.PROP_KEY_BG_MUSIC_Play = "room:RoomElement:bgMusicPlay";
